import { useEditClientContractTermHeader } from './hooks';
import { convertToPresentationProps } from './logics';
import { EditClientContractTermHeaderPresentation } from './presentations';

type Props = {
  /** 利用企業 ID（Screen 層でパース・検証済みの数値） */
  clientId: number;
  /** 企業契約期間 ID（Screen 層でパース・検証済みの数値） */
  termId: number;
};

/**
 * 企業契約期間 編集ヘッダー Container コンポーネント
 *
 * 企業契約期間 API から取得した利用企業名を breadcrumb 付きページヘッダーに表示する。
 * 契約プラン情報（プラン名・種別等）は表示しない（本体側の表示は T03 の担当）。
 *
 * @param clientId - 利用企業 ID（Screen 層でパース・検証済みの数値）
 * @param termId - 企業契約期間 ID（Screen 層でパース・検証済みの数値）
 */
export const EditClientContractTermHeader: React.FC<Props> = ({ clientId, termId }) => {
  const {
    state: { data },
  } = useEditClientContractTermHeader({ clientId, termId });

  const { clientName } = convertToPresentationProps({ data });

  return <EditClientContractTermHeaderPresentation clientName={clientName} />;
};
